// Global toast bridge — lets the API interceptor trigger toasts from outside React.
// Register the showToast function once on app mount (see AppProviders.tsx).

type ToastType = 'success' | 'error' | 'warning' | 'info';
type ShowToastFn = (message: string, type?: ToastType) => void;

let _showToast: ShowToastFn | null = null;

export function registerGlobalToast(fn: ShowToastFn): void {
  _showToast = fn;
}

export function globalToast(message: string, type: ToastType = 'error'): void {
  _showToast?.(message, type);
}
